<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_blue_back" style="background-color: #5C82A5;">
      <div class="rew19_header_title">
        <h2>Nourish the Children 정기 기부 소개</h2>
        <p>구매하신 바이타밀이 자동적으로 공인 구호단체에 기부되어 영양 결핍으로 고통받는 어린이들에게 전달되는 프로그램입니다.</p>
      </div>
    </div>

    <div class="rew19_contents_inner">
      <sns-link
        :class="'rew19_noTitle'"
        :snsLinkUrl="snsLinkUrl"
        :snsTitle="'Nurish the Children 정기 기부 소개'"
        :snsImgUrl="'https://resource2018.nuskinkorea.co.kr/images/aro/info_nourish_mb.png'"
      />

      <div class="rew19_infoImg">
        <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_nourish.png"
          alt="온라인에서 정기기부프로그램을 신청하면 매월 자동적으로 정해진 날짜에 정해진 수량의 타이타밀을 구매하여 공인 구호 단체로 기부하게되는 시스템으로, 구매에 대한 번거로움없이 정기적으로 영양결핍에 시달리고있는 어린이들에게 따뜻한 생명의 식사를 나누어 줄 수 있습니다" class="viewPc">
        <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_nourish_mb.png"
          alt="온라인에서 정기기부프로그램을 신청하면 매월 자동적으로 정해진 날짜에 정해진 수량의 타이타밀을 구매하여 공인 구호 단체로 기부하게되는 시스템으로, 구매에 대한 번거로움없이 정기적으로 영양결핍에 시달리고있는 어린이들에게 따뜻한 생명의 식사를 나누어 줄 수 있습니다" class="viewMb">
      </div>
      <ul class="rew19_aroStep_wrap">
        <li class="rew19_aroStep">
          <h4 class="limitTop">
            <span>1 STEP_기부 제품 선택</span>
          </h4>
          <p class="rew19_addExplain">
            정기 기부할 제품(바이타밀)과 수량을 선택하여 장바구니에 담습니다. 정기기부 프로그램 외에 개별로 바이타밀을 구매하여 기부하시려면 홈페이지, 전화 또는 라이브센터(KIOSK)에서 이용하실 수 있습니다
          </p>
        </li>
        <li class="rew19_aroStep">
          <h4 class="limitTop">
            <span>2 STEP_정기 기부 참여 동의서 작성 (카드 결제/결제일 선택)</span>
          </h4>
          <p class="rew19_addExplain">
            정기 기부 참여 동의서 작성 후 프로그램 이용이 가능합니다. 정기 기부 프로그램은 신용카드 결제만 가능하며, 매월 지정일에 일시불로 승인 받습니다. 한달에 1번(3~19일 중 택1일) 선택하신 지정일에 결제가 이루어 지게 됩니다.
          </p>
        </li>
        <li class="rew19_aroStep">
          <h4 class="limitTop">
            <span>3 STEP_공인구호 단체 전달</span>
          </h4>
          <p class="rew19_addExplain">
            정기적으로 영양 결핍에 시달리고 있는 어린이들에게 따뜻한 생명의 식사를 나누어 줄 수 있습니다.
          </p>
        </li>
      </ul>
    </div><!--rew19_contents_inner-->
    <div class="infographics_wrap">
      <div class="rew19_grayInner">
        <h4>정기기부 프로그램 유의사항</h4>
        <p>
          너리시더 칠드런은 회원님께서 구매하신 바이타밀이 자동적으로 공인 구호단체에 기부되어 영양 결핍으로 고통받는 어린이에게 전달되는 프로세스로 운영됩니다. <br/>
          이 프로세스는 30일 정도의 기간이 소요됩니다. 따라서 결제일로부터 30일 이후에는 회원님께서 구매하신 제품이 어린이들의 식사로 제공되고 있는 상태이므로 환불 및 반품이 불가함을 알려드립니다.<br/>
          단, 결제일로부터 30일 이내에 회사로 약정해지 통보 시 청약 철회가 가능합니다. 철회 및 반품 문의는 콜센터 전화 문의 및 워크인 센터로 방문하여 접수하실 수 있습니다.
        </p>
        <div class="rew19_responsive_btns">
          <a :href="$aroBasePath+'/listNtc'" class="rew19-btn-blue">NTC 정기기부 신청</a>
        </div>
      </div><!--rew19_contents_inner-->
    </div>
  </div><!--rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import SnsLink from './snsLink';

export default {
  name: 'NourishIntroduce',
  extends: AroBase,
  components: { SnsLink },
  props: {},
  computed : {
    snsLinkUrl : function(){
      let linkUrl = document.location.href;
      let addParams = 'utm_source=kakaotalk&utm_medium=product_detail';
      linkUrl+=(linkUrl.indexOf("?") > 0 ? "&" : "?") + addParams;
      return linkUrl;
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;
  },
  methods :{

  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/info/nourishIntroduce.vue